import { PRIMARY_COLOR } from "../_const/color.const";

export const sidebarStyles = {
    logo: {
        width: "230px",
        marginTop: "10px",
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: "10px"
    },
    regularItem: {
        backgroundColor: 'auto',
        color: 'auto',
        pl: 4,
        marginLeft: '26px',
        paddingLeft: '12px',
        borderLeft: '1px solid grey'
    },
    activeItem: {
        backgroundColor: PRIMARY_COLOR,
        color: '#fff',
        pl: 4,
        marginLeft: '26px',
        paddingLeft: '12px',
        borderLeft: '1px solid grey',
        "&:hover": {
            backgroundColor: PRIMARY_COLOR,
            opacity: 0.7,
        }
    },
};